/* eslint-disable no-console */
import Vue from 'vue'
import sentryPlugin from '@/plugins/sentryPlugin'
import authPlugin from '@/plugins/authPlugin'
import i18n from '@/plugins/i18nPlugin'
import router from './router'
import SnackMessagesPlugin from './plugins/SnackMessagesPlugin'
import vuetify from './plugins/vuetify'
import store from './store'
import PortalVue from 'portal-vue'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import App from './App.vue'

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  console.error('Vue.config.errorHandler =====================')
  console.error('err: ', err)
  console.error('vm: ', vm)
  console.error('info: ', info)
  console.error('=============================================')
}

Vue.use(PortalVue)
Vue.use(sentryPlugin)
Vue.use(authPlugin)
Vue.use(SnackMessagesPlugin)

window.eventBus = new Vue({})

new Vue({
  store,
  router,
  i18n,
  vuetify,
  computed: {
    userLocale () {
      const lang = this.$auth.preferredLanguage
      return lang
    }
  },
  watch: {
    userLocale: {
      handler (value) {
        if (!this.$store.state.preferences.locale) {
          this.$store.dispatch('preferences/setLocale', value)
        }
      },
      immediate: true
    }
  },
  created () {
    console.log('Vue.main.created()', this.$auth)
    this.$store.dispatch('preferences/initialize')
  },
  render: h => h(App)
}).$mount('#app')
